import { render, staticRenderFns } from "./cloudServer.vue?vue&type=template&id=9b8a3252&scoped=true&"
import script from "./cloudServer.vue?vue&type=script&lang=js&"
export * from "./cloudServer.vue?vue&type=script&lang=js&"
import style0 from "./cloudServer.vue?vue&type=style&index=0&id=9b8a3252&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8a3252",
  null
  
)

export default component.exports